const EmptyClass = ""; // emptyspace flex-1 <- working bad at ios 😒
const EmptySpace = () => <div className={ EmptyClass } />
export default EmptySpace;